module.exports = __webpack_public_path__ + "img/marine_card.90cb322f.jpg";